import React, { useState, useRef,  useEffect } from "react";
import { RiSendPlaneFill } from "react-icons/ri";
import "../../index.css";
import robot from "../images/robot.png";
import tree from "../images/tree.png";

import {
  // response,
  handler,
} from "../brains/chat/convVectorMem";

const ChatSection = ({
  chats,
  isChatLoading,
  // setUserMessageHighlights,
  // allChatsHighlights,
  // allMessageHighlights,

}) => {
  const [message, setMessage] = useState("");
  const [allChats, setAllChats] = useState(chats);
  const [aiMessage, setAiMessage] = useState({});


  const textAreaRef = useRef(null); // Create a ref
  const [data, setData] = useState([]);
  // useEffect(() => {
  //   setAllChats((prevChats) => [...prevChats, allChatsHighlights]);
  // }, [allChatsHighlights]);
  // var newChat;
  useEffect(() => {
    if (data.length > 0) {
      const combinedString = data.join(' '); // Join array elements with a space in between
      setAiMessage({ sender: 'ai', message: combinedString })
      // setAllChats((prevAllMes) => [...prevAllMes, { sender: 'ai', message: combinedString }]);
    }
  }, [data]);
  
  useEffect(() => {

  }, [allChats]);



  const handleSend = async () => {
    // Process the message here
    setData([]);

    if (message.length > 0) {
      if (aiMessage.sender === 'ai') {
        setAllChats((prevChats) => [...prevChats, aiMessage, { message: message, sender: "user" }]);
      }


      else {
        setAllChats((prevChats) => [...prevChats, { message: message, sender: "user" }]);
      }

    }

    // await analyzeText(message)

    if (aiMessage.sender !== 'ai') {
      await handler(message + ' ' + allChats[0].message, 0, setData);

    }
    else {
    setAiMessage({});

      await handler(message, 0, setData);
    }

    setMessage(""); // Clear the textarea after sending the message
  };

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  }
  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  const handleSuggestion = async (event) => {
    const text = event.target.textContent;
    // setMessage(text + ' ' + allChats[0].message);
    // handleSend()

    const newMessage = text + ' ' + allChats[0].message


    setData([]);

    if (newMessage.length > 0) {
      if (aiMessage.sender === 'ai') {
        setAllChats((prevChats) => [...prevChats, aiMessage, { message: newMessage, sender: "user" }]);
      }


      else {
        setAllChats((prevChats) => [...prevChats, { message: newMessage, sender: "user" }]);
      }

    }

    // await analyzeText(message)

    if (aiMessage.sender !== 'ai') {
      await handler(message + ' Use the following text to answer this: ' + allChats[0].message, 0, setData);

    }
    else {
    setAiMessage({});

      await handler(message, 0, setData);
    }



    // console.log("handleSuggestion" , text);
  };


  return (
    <section style={{ backgroundColor: "#eee", width: "100%", height: "100%" }}>
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center h-100">
          <div className="w-full">
            <div
              className="card h-100"
              id="chat1"
              style={{ borderRadius: "15px" }}
            >
              <div
                className="card-header d-flex justify-content-between align-items-center p-3 bg-info text-white border-bottom-0"
                style={{
                  borderTopLeftRadius: "15px",
                  borderTopRightRadius: "15px"
                }}
              >
                <i className="fas fa-angle-left"></i>
                <p className="mb-0 fw-bold">AI Highlight Chat</p>
                <i className="fas fa-times"></i>
              </div>
              <div
                className="card-body"
                style={{ maxHeight: "calc(100% - 92px)", overflowY: "scroll" }}
              >
                {/* {chats.map((chat, index) => ( */}
                {allChats.map((chat, index) => (

                  <div
                    key={index}
                    className={`d-flex flex-row justify-content-${chat.sender === "ai" ? "start" : "end"
                      } mb-4`}
                  >
                    {chat.sender === "ai" && (
                      <img
                        src={robot}
                        alt="avatar 1"
                        style={{ width: "45px", height: "100%" }}
                      />
                    )}
                    <div
                      className={`${chat.sender === "ai" ? "p-3 ms-3" : "p-3 me-3 border"
                        }`}
                      style={{
                        borderRadius: "15px",
                        backgroundColor:
                          chat.sender === "ai"
                            ? "rgba(57, 192, 237, .2)"
                            : "#fbfbfb"
                      }}
                    >
                      <p className="small mb-0">{chat.message}</p>
                    </div>
                    {chat.sender !== "ai" && (
                      <img
                        src={tree}
                        alt="human 1"
                        style={{ width: "45px", height: "100%" }}
                      />
                    )}
                  </div>
                ))}

                {/* not highlight text */}
                {aiMessage.sender === 'ai' && [aiMessage]?.map((chat, index) => (
                  <div
                    key={index}
                    className={`d-flex flex-row justify-content-${index % 2 === 0 ? "start" : "end"
                      } mb-4`}
                  >
                    {index % 2 === 0 && (
                      <img
                        src={robot}
                        alt="avatar 1"
                        style={{ width: "45px", height: "100%" }}
                      />
                    )}
                    <div
                      className={`${chat.sender === "ai" ? "p-3 ms-3" : "p-3 me-3 border"
                        }`}
                      style={{
                        borderRadius: "15px",
                        backgroundColor:
                          chat.sender === "ai"
                            ? "rgba(57, 192, 237, .2)"
                            : "#fbfbfb"
                      }}
                    >
                      <p className="small mb-0">{chat.message}</p>
                    </div>
                    {/* {index % 2 === 0 && (
                      <img
                        src={robot}
                        alt="avatar 1"
                        style={{ width: "45px", height: "100%" }}
                      />
                    )} */}
                  </div>
                ))}





                <div className="form-outline mb-4">
                  <div>
                    <span
                      className="chat-badge rounded mx-auto text-white"
                      onClick={handleSuggestion}
                    >
                      What is the theory behind this?
                    </span>
                    <br />
                    <br />
                    <span
                      className="chat-badge rounded mx-auto text-white"
                      onClick={handleSuggestion}
                    >
                      Describe this in simple terms
                    </span>
                    <br />
                    <br />
                  </div>
                  <div className="position-relative">
                    <div style={{ position: "relative" }}>
                      <textarea
                        className="form-control"
                        id="textAreaExample"
                        placeholder="Ask me anything"
                        rows="4"
                        value={message}
                        onKeyDown={handleKeyDown}
                        onChange={handleChange}
                        ref={textAreaRef} 
                        style={{ marginBottom: "0" }}
                      ></textarea>
                      {/* <label className="form-label" htmlFor="textAreaExample">
                        Type your message
                      </label> */}
                    </div>
                    {isChatLoading === 1 ? (
                      <button
                        className="btn btn-primary"
                        type="button"
                        disabled
                      >
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary"
                        onClick={handleSend}
                        disabled={isChatLoading}
                        style={{
                          position: "absolute",
                          bottom: "10px",
                          right: "10px"
                        }}
                      >
                        <RiSendPlaneFill />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChatSection;
